import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { Subscription } from 'rxjs';
import { filter, first, tap } from 'rxjs/operators';
import { AnalyticsService } from 'services';

export const isEveryConsentSelected = (consents) => Object.values(consents).every(Boolean);
export const isAtLeastOneConsentSelected = (consents) => !isEveryConsentSelected(consents) && Object.values(consents).some(Boolean);

@Component({
  selector: 'sb-consent-form',
  templateUrl: './consent-form.component.html',
  styleUrls: ['./consent-form.component.scss']
})
export class ConsentFormComponent implements OnInit, OnDestroy {
  @Input() formGroup: FormGroup;
  @Input() shouldShowAllConsents: boolean;
  @Output() toggleConsentsEvent = new EventEmitter();

  private subscriptions: Subscription = new Subscription();

  ngOnInit() {}

  public onConsentClick($event) {
    if ($event && $event.preventDefault) {
      $event.preventDefault();
    }
    // if (isEveryConsentSelected(this.formGroup.value)) {
      // this.formGroup.reset();
    // }
    this.toggleConsentsEvent.emit();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}
